import AddDriverManager from '@root/bind.joinroot.com/src/components/bind-add-driver/add-driver-manager';
import BindView from '@root/bind.joinroot.com/src/components/bind-view';
import CloseModalButton from '@root/bind.joinroot.com/src/components/close-modal-button';
import PropTypes from '@root/vendor/prop-types';
import React, { useMemo } from '@root/vendor/react';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import useBranding from '@root/bind.joinroot.com/src/context/branding';
import { Colors, Shadows, StyleSheet } from '@root/core/src/utils/styles';

export const ANALYTICS_CONTEXT = 'BIND_ADD_DRIVER';
export const ANALYTICS_EVENTS = {
  CLOSE_MODAL_BUTTON: 'CLOSE_MODAL_BUTTON',
};

const BindAddDriver = ({
  onCancel,
  onUpdateProfileParams,
  profileParams,
  profileRules,
  shouldReturnToPartnerOnBack,
}) => {
  const { trackClick } = useAnalytics(ANALYTICS_CONTEXT);
  const [useBrandingState] = useBranding();
  const brandStyles = useMemo(() => stylesGenerator(useBrandingState), [useBrandingState]);

  const handleModalClose = () => {
    trackClick(ANALYTICS_EVENTS.CLOSE_MODAL_BUTTON);
    onCancel();
  };

  return (
    <>
      {shouldReturnToPartnerOnBack ?
        <BindView.ExitFlowButton exitToQuote /> :
        <BindView.BackToProfileButton onClick={onCancel} />
      }
      <BindView>
        <BindView.Card
          cssOverrides={{
            marginTop: 50,
          }}
        >
          <CloseModalButton onClick={handleModalClose} />
          <AddDriverManager
            brandedColor={useBrandingState.primaryColor}
            brandStyles={brandStyles}
            chevronStyle={useBrandingState.chevronDown}
            cssButtonOverrides={brandStyles.buttonStyle}
            dropdownIndicatorColor={useBrandingState.secondaryColor}
            inputStyle={brandStyles.inputStyle}
            linkStyles={brandStyles.linkStyles}
            onCancel={onCancel}
            onUpdateProfileParams={onUpdateProfileParams}
            optionStyles={brandStyles.optionStyles}
            profileParams={profileParams}
            profileRulesContext={profileRules}
            selectBoxFocusedStyles={brandStyles.selectBoxFocusedStyles}
            selectBoxStyles={brandStyles.selectBoxStyles}
          />
        </BindView.Card>
      </BindView>
    </>
  );
};

const stylesGenerator = ({ infoColor, primaryColor }) => StyleSheet.create({
  buttonStyle: {
    background: primaryColor,
    ...Shadows.onFocusStateShadow({}, primaryColor),
  },
  inputStyle: {
    caretColor: infoColor,
    ':focus': {
      borderColor: infoColor,
    },
  },
  linkStyles: {
    ':hover': {
      color: primaryColor,
    },
  },
  optionStyles: {
    ':hover, :hover > span': {
      background: Colors.gray20(),
      color: Colors.black(),
    },
  },
  selectBoxStyles: {
    ':focus': {
      borderColor: infoColor,
    },
  },
  selectBoxFocusedStyles: {
    borderColor: infoColor,
  },
});

BindAddDriver.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onUpdateProfileParams: PropTypes.func.isRequired,
  profileParams: PropTypes.object.isRequired,
  profileRules: PropTypes.object.isRequired,
  shouldReturnToPartnerOnBack: PropTypes.bool,
};

export default BindAddDriver;
